import {
  SET_WIDGET_TITLE,
  SET_RING_TREES,
  SET_RING_TREE,
  SET_RING_TREE_TARGETS,
  SET_USER_VISIBLE_COLUMNS,
  SET_RING_TREE_REFERENCES,
  SET_CHECK_REFERENCES_TEXT
} from './mutationTypes';

import {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError
} from '@/store/helpers';
import cloneDeep from 'lodash/cloneDeep';

export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_RING_TREES](state, ringTrees) {
    state.ringTrees = ringTrees;
  },
  [SET_WIDGET_TITLE](state, title) {
    state.widget.title = title;
  },
  [SET_USER_VISIBLE_COLUMNS](state, userVisibleColumns) {
    state.userVisibleColumns = userVisibleColumns;
  },
  [SET_RING_TREE](state, { index, ringTree }) {
    const arrayToUpdate = cloneDeep(state.ringTrees);
    arrayToUpdate[index] = ringTree;
    state.ringTrees = arrayToUpdate;
  },
  [SET_RING_TREE_TARGETS](state, ringTreeTargets) {
    state.currentTargets = ringTreeTargets;
  },
  [SET_RING_TREE_REFERENCES](state, ringTreeReferences) {
    state.ringTreeReferences = ringTreeReferences;
  },
  [SET_CHECK_REFERENCES_TEXT](state, checkReferencesText) {
    state.checkReferencesText = checkReferencesText;
  }
};
